import { BookingDetails } from "@/models";
import { BookingDetailsApiDTO } from "../dtos";

export const mapBookingDetailsApiDTOtoBookingDetails = (
  bookingDetailsDTO: BookingDetailsApiDTO["data"]
): BookingDetails => {
  return {
    roomId: bookingDetailsDTO.roomId,
    booking: bookingDetailsDTO.booking,
    guestFirstName: bookingDetailsDTO.guestFirstName,
    guestLastName: bookingDetailsDTO.guestLastName,
    phone: bookingDetailsDTO.phone,
    age: bookingDetailsDTO.age,
    email: bookingDetailsDTO.email,
    nationality: bookingDetailsDTO.nationality,
    pax: bookingDetailsDTO.pax,
    otaOrigin: bookingDetailsDTO.otaOrigin,
    pmsOrigin: bookingDetailsDTO.pmsOrigin,
    otaReservationNumber: bookingDetailsDTO.otaReservationNumber,
    pmsReservationNumber: bookingDetailsDTO.pmsReservationNumber,
    totalCost: bookingDetailsDTO.totalCost ?? undefined,
    vat: bookingDetailsDTO.vat ?? undefined,
    cityTax: bookingDetailsDTO.cityTax ?? undefined,
    commission: bookingDetailsDTO.commission ?? undefined,
    paid: bookingDetailsDTO.paid ?? undefined,
    deposit: bookingDetailsDTO.deposit ?? undefined,
    pendingPayment: bookingDetailsDTO.pendingPayment ?? undefined,
    checkInDatetime: bookingDetailsDTO.checkInDatetime,
    checkOutDatetime: bookingDetailsDTO.checkOutDatetime,
    arrivalMethod: bookingDetailsDTO.arrivalMethod,
    flightNumber: bookingDetailsDTO.flightNumber,
    accessType: bookingDetailsDTO.accessType,
    keyStatus: bookingDetailsDTO.keyStatus,
    accessCode1: bookingDetailsDTO.accessCode1,
    accessCode2: bookingDetailsDTO.accessCode2,
    callbackMessages: bookingDetailsDTO.callbackMessages,
    booker: bookingDetailsDTO.booker,
    additionalGuests: bookingDetailsDTO.additionalGuests,
  };
};
